import React from 'react';

// Linea-style thin line icons as React components

export const LineaCompass = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <circle cx="32" cy="32" r="28" strokeWidth="1.5" opacity="0.3"/>
    <circle cx="32" cy="32" r="20" strokeWidth="1.5" opacity="0.5"/>
    <circle cx="32" cy="32" r="12" strokeWidth="1.5" opacity="0.7"/>
    <circle cx="32" cy="32" r="2" fill="currentColor"/>
    <line x1="32" y1="8" x2="32" y2="18" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="32" y1="46" x2="32" y2="56" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <line x1="8" y1="32" x2="18" y2="32" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <line x1="46" y1="32" x2="56" y2="32" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <path d="M32 20 L36 28 L32 26 L28 28 Z" fill="currentColor"/>
  </svg>
);

export const LineaShield = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M32 6 L52 18 L52 38 C52 48 42 56 32 58 C22 56 12 48 12 38 L12 18 Z" strokeWidth="1.5" fill="none"/>
    <path d="M28 32 L30 34 L36 28" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaLightning = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M35 6 L24 36 L32 36 L29 58 L48 26 L38 26 Z" strokeWidth="1.5" fill="currentColor" fillOpacity="0.2" strokeLinejoin="round"/>
  </svg>
);

export const LineaGauge = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M12 42 A 20 20 0 1 1 52 42" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M16 38 A 16 16 0 1 1 48 38" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <line x1="32" y1="42" x2="32" y2="26" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="32" cy="42" r="2" fill="currentColor"/>
  </svg>
);

export const LineaClock = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <circle cx="32" cy="32" r="24" strokeWidth="1.5"/>
    <line x1="32" y1="32" x2="32" y2="16" strokeWidth="2" strokeLinecap="round"/>
    <line x1="32" y1="32" x2="44" y2="32" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="32" cy="32" r="1.5" fill="currentColor"/>
  </svg>
);

export const LineaRotate = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M32 10 A 22 22 0 1 1 16 18" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M32 10 L28 16 L36 16 Z" fill="currentColor"/>
    <circle cx="32" cy="32" r="3" fill="currentColor"/>
  </svg>
);

export const LineaDownload = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <line x1="32" y1="12" x2="32" y2="42" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M24 34 L32 42 L40 34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 52 L50 52" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M18 46 L18 52" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M46 46 L46 52" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const LineaSmartphone = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <rect x="20" y="8" width="24" height="48" rx="3" strokeWidth="1.5"/>
    <line x1="28" y1="50" x2="36" y2="50" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="26" y1="14" x2="38" y2="14" strokeWidth="1" strokeLinecap="round" opacity="0.3"/>
  </svg>
);

export const LineaMonitor = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <rect x="8" y="12" width="48" height="32" rx="2" strokeWidth="1.5"/>
    <line x1="24" y1="54" x2="40" y2="54" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="32" y1="44" x2="32" y2="54" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const LineaTarget = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <circle cx="32" cy="32" r="24" strokeWidth="1.5"/>
    <circle cx="32" cy="32" r="16" strokeWidth="1.5"/>
    <circle cx="32" cy="32" r="8" strokeWidth="1.5"/>
    <circle cx="32" cy="32" r="2" fill="currentColor"/>
  </svg>
);

export const LineaArrowRight = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <line x1="12" y1="32" x2="52" y2="32" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M44 24 L52 32 L44 40" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ArrowRight = LineaArrowRight;

export const LineaCheck = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <circle cx="32" cy="32" r="26" strokeWidth="1.5"/>
    <path d="M20 32 L28 40 L44 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaChevronDown = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M16 24 L32 40 L48 24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaUsers = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <circle cx="24" cy="22" r="8" strokeWidth="1.5"/>
    <path d="M10 52 C10 42 14 38 24 38 C34 38 38 42 38 52" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="44" cy="20" r="7" strokeWidth="1.5"/>
    <path d="M44 34 C50 34 54 36 54 44" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const LineaTrophy = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M20 10 L20 22 C20 32 24 36 32 36 C40 36 44 32 44 22 L44 10" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="20" y1="10" x2="44" y2="10" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M16 12 C12 12 10 14 10 18 C10 22 12 24 16 24" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M48 12 C52 12 54 14 54 18 C54 22 52 24 48 24" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="32" y1="36" x2="32" y2="48" strokeWidth="1.5"/>
    <line x1="24" y1="48" x2="40" y2="48" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="26" y1="54" x2="38" y2="54" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const LineaFingerprint = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M32 12 C20 12 16 20 16 28 C16 36 20 44 32 52" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M32 18 C24 18 22 24 22 28 C22 32 24 38 32 44" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M32 24 C28 24 28 26 28 28 C28 30 28 34 32 38" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M42 20 C44 22 48 26 48 32 C48 38 44 44 40 48" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M38 24 C40 26 42 28 42 32 C42 36 40 40 36 44" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const LineaActivity = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M8 32 L18 32 L24 18 L32 46 L40 18 L46 32 L56 32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaSwords = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    {/* First sword - diagonal from bottom-left to top-right */}
    <line x1="16" y1="48" x2="48" y2="16" strokeWidth="2"/>
    <path d="M12 52 L16 48 L20 52 L16 56 Z" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.2"/>
    <path d="M44 12 L48 16 L52 12 L48 8 Z" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.2"/>
    {/* Second sword - diagonal from top-left to bottom-right */}
    <line x1="48" y1="48" x2="16" y2="16" strokeWidth="2"/>
    <path d="M52 52 L48 48 L44 52 L48 56 Z" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.2"/>
    <path d="M20 12 L16 16 L12 12 L16 8 Z" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.2"/>
    {/* Center cross point highlight */}
    <circle cx="32" cy="32" r="3" fill="currentColor" fillOpacity="0.3"/>
  </svg>
);

export const LineaExternal = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M40 12 L52 12 L52 24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="52" y1="12" x2="32" y2="32" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M44 26 L44 52 L12 52 L12 20 L38 20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaArrowLeft = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <line x1="52" y1="32" x2="12" y2="32" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M20 24 L12 32 L20 40" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaDoubleArrowRight = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M14 24 L22 32 L14 40" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M30 24 L38 32 L30 40" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M46 24 L54 32 L46 40" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaHeadToHead = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <circle cx="20" cy="20" r="6" strokeWidth="1.5"/>
    <circle cx="44" cy="20" r="6" strokeWidth="1.5"/>
    <path d="M12 44 C12 36 14 32 20 32 C26 32 28 36 28 44" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M36 44 C36 36 38 32 44 32 C50 32 52 36 52 44" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="28" y1="38" x2="36" y2="38" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M26 38 L28 34 L30 38" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 38 L36 34 L34 38" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LineaCompetitive = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <rect x="24" y="36" width="16" height="20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="10" y="44" width="14" height="12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="40" y="48" width="14" height="8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M32 36 L32 28 L28 24 L32 18 L36 24 L32 28" strokeWidth="1.5" strokeLinejoin="round"/>
    <circle cx="32" cy="18" r="3" strokeWidth="1.5"/>
    <line x1="32" y1="8" x2="32" y2="15" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const LineaDoubleTriangleRight = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" {...props}>
    <path d="M18 18 L32 32 L18 46 Z" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.3"/>
    <path d="M34 18 L48 32 L34 46 Z" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.3"/>
  </svg>
);